export default "__VITE_ASSET__BLUMgtoK__"